/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EvaluationParameterDto } from './EvaluationParameterDto';
import {
    EvaluationParameterDtoFromJSON,
    EvaluationParameterDtoFromJSONTyped,
    EvaluationParameterDtoToJSON,
} from './EvaluationParameterDto';
import type { ManualTaskWorkResultDto } from './ManualTaskWorkResultDto';
import {
    ManualTaskWorkResultDtoFromJSON,
    ManualTaskWorkResultDtoFromJSONTyped,
    ManualTaskWorkResultDtoToJSON,
} from './ManualTaskWorkResultDto';
import type { ParameterCombinationDto } from './ParameterCombinationDto';
import {
    ParameterCombinationDtoFromJSON,
    ParameterCombinationDtoFromJSONTyped,
    ParameterCombinationDtoToJSON,
} from './ParameterCombinationDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { WorkState } from './WorkState';
import {
    WorkStateFromJSON,
    WorkStateFromJSONTyped,
    WorkStateToJSON,
} from './WorkState';

/**
 * 
 * @export
 * @interface ManualTaskWorkStepDto
 */
export interface ManualTaskWorkStepDto {
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkStepDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkStepDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof ManualTaskWorkStepDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkStepDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ManualTaskWorkStepDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {ParameterCombinationDto}
     * @memberof ManualTaskWorkStepDto
     */
    combination?: ParameterCombinationDto;
    /**
     * 
     * @type {Array<EvaluationParameterDto>}
     * @memberof ManualTaskWorkStepDto
     */
    evaluations?: Array<EvaluationParameterDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ManualTaskWorkStepDto
     */
    isExecutable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkStepDto
     */
    workStepPreviewId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ManualTaskWorkStepDto
     */
    evaluationIds?: Array<string> | null;
    /**
     * 
     * @type {WorkState}
     * @memberof ManualTaskWorkStepDto
     */
    workState?: WorkState;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkStepDto
     */
    workflowId?: string | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof ManualTaskWorkStepDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkStepDto
     */
    commentEntityCompositeId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ManualTaskWorkStepDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkStepDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ManualTaskWorkStepDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof ManualTaskWorkStepDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof ManualTaskWorkStepDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {Array<ManualTaskWorkResultDto>}
     * @memberof ManualTaskWorkStepDto
     */
    results?: Array<ManualTaskWorkResultDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkStepDto
     */
    $type?: ManualTaskWorkStepDtoTypeEnum;
}


/**
 * @export
 */
export const ManualTaskWorkStepDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoManualTaskWorkStepDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualTaskWorkStepDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ManualTaskWorkStepDtoTypeEnum = typeof ManualTaskWorkStepDtoTypeEnum[keyof typeof ManualTaskWorkStepDtoTypeEnum];


/**
 * Check if a given object implements the ManualTaskWorkStepDto interface.
 */
export function instanceOfManualTaskWorkStepDto(value?: unknown): value is ManualTaskWorkStepDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ManualTaskWorkStepDtoTypeEnum)[0];
}

export function ManualTaskWorkStepDtoFromJSON(json: any): ManualTaskWorkStepDto {
    return ManualTaskWorkStepDtoFromJSONTyped(json, false);
}

export function ManualTaskWorkStepDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualTaskWorkStepDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'combination': !exists(json, 'combination') ? undefined : ParameterCombinationDtoFromJSON(json['combination']),
        'evaluations': !exists(json, 'evaluations') ? undefined : (json['evaluations'] === null ? null : (json['evaluations'] as Array<any>).map(EvaluationParameterDtoFromJSON)),
        'isExecutable': !exists(json, 'isExecutable') ? undefined : json['isExecutable'],
        'workStepPreviewId': !exists(json, 'workStepPreviewId') ? undefined : json['workStepPreviewId'],
        'evaluationIds': !exists(json, 'evaluationIds') ? undefined : json['evaluationIds'],
        'workState': !exists(json, 'workState') ? undefined : WorkStateFromJSON(json['workState']),
        'workflowId': !exists(json, 'workflowId') ? undefined : json['workflowId'],
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'commentEntityCompositeId': !exists(json, 'commentEntityCompositeId') ? undefined : json['commentEntityCompositeId'],
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'creatorUser': !exists(json, 'creatorUser') ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ManualTaskWorkResultDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ManualTaskWorkStepDtoToJSON(value?: ManualTaskWorkStepDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'combination': ParameterCombinationDtoToJSON(value.combination),
        'evaluations': value.evaluations === undefined ? undefined : (value.evaluations === null ? null : (value.evaluations as Array<any>).map(EvaluationParameterDtoToJSON)),
        'isExecutable': value.isExecutable,
        'workStepPreviewId': value.workStepPreviewId,
        'evaluationIds': value.evaluationIds,
        'workState': WorkStateToJSON(value.workState),
        'workflowId': value.workflowId,
        'lastModifierUser': UserCatalogDtoToJSON(value.lastModifierUser),
        'commentEntityCompositeId': value.commentEntityCompositeId,
        'commentCount': value.commentCount,
        'lastComment': value.lastComment,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'creatorUser': UserCatalogDtoToJSON(value.creatorUser),
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ManualTaskWorkResultDtoToJSON)),
        '$type': value.$type,
    });
}

